import Cascader from './Cascader';
import DatePicker from './DatePicker';
import Dropdown from './Dropdown';
import Editor from './Editor';
import ImageViewer from './ImageViewer';
import Input from './Input';
import Modal from './Modal';
import Pagination from './Pagination';
import Popover from './Popover';
import Select from './Select';
import Table from './Table';
import TimePicker from './TimePicker';
import Transfer from './Transfer';
import Upload from './Upload';
import YearMonthSwitch from './YearMonthSwitch';
var messages = {
  Cascader: Cascader,
  DatePicker: DatePicker,
  Dropdown: Dropdown,
  Editor: Editor,
  ImageViewer: ImageViewer,
  Input: Input,
  Modal: Modal,
  Pagination: Pagination,
  Popover: Popover,
  Select: Select,
  Table: Table,
  TimePicker: TimePicker,
  Transfer: Transfer,
  Upload: Upload,
  YearMonthSwitch: YearMonthSwitch
};
export default messages;